(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.contact-email', ['pp.widgets-templates']);

ngModule.component('ppContactEmail', {
    templateUrl: 'widgets/_angular/contact-email/contact-email.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);